import React from 'react';
import {
  bookNewAppWithApp,
  setAppPopup,
  setGlobalAppId,
  setIsCheckoutProcess,
} from '../../../redux/slices/scheduler/appointmentSlice';
import { useDispatch } from 'react-redux';
import { setSeltSerchPat } from '../../../redux/slices/patient/patientSlice';

function FutureAppListPopup({ futureAppData, handleClose }) {
  const dispatch = useDispatch();
  const handleNewApp = () => {
    dispatch(setAppPopup(true));
    dispatch(
      setSeltSerchPat({
        patId: futureAppData?.patientId,
        getPatientType: futureAppData?.selPatientType,
        getNewPatientType: futureAppData?.selNewPatientType,
        patName: futureAppData?.patientName,
      })
    );

    dispatch(bookNewAppWithApp(true));
    dispatch(
      setIsCheckoutProcess({
        status: true,
        appid: futureAppData?.appId,
        curStatAutoIncId: futureAppData?.curStatAutoIncId,
      })
    );

    handleClose();
  };

  const handleExestApp = (appId, futAppId) => {
    dispatch(setAppPopup(true));
    dispatch(setGlobalAppId(futAppId));
    dispatch(
      setIsCheckoutProcess({
        status: true,
        appid: appId,
        curStatAutoIncId: futureAppData?.curStatAutoIncId,
      })
    );

    handleClose();
  };
  return (
    <div className="modalBackground" style={{ zIndex: '10' }}>
      <div style={{ width: '400px', backgroundColor: '#fff' }}>
        <div className="prgrs-tmplt-hdr width100">
          <span className="tmplt-hdr-hdng fontsize15">Suggestion:</span>
          <span
            className="right clear-right tmplt-cross "
            onClick={handleClose}
          >
            x
          </span>
        </div>
        <div
          className="sp-dm-bdy fontsize13"
          style={{ padding: '0px 15px 10px 15px' }}
        >
          <div className="sp-dem-rw">
            <span
              dangerouslySetInnerHTML={{
                __html: futureAppData?.futAppStr
                  ? futureAppData?.futAppStr
                  : '',
              }}
            />
            {/* {futureAppData?.futAppStr} */}
          </div>
          <div className="sp-dem-rw">
            <div className="linkColor" onClick={handleNewApp}>
              Click here to book a <u>[New Appointment]</u>
            </div>
            <div
              className="linkColor clear-top10"
              onClick={() =>
                handleExestApp(futureAppData?.appId, futureAppData?.futAppId)
              }
            >
              Click here to <u>[Use/ Change Existing]</u>
            </div>
          </div>
        </div>
        <div className="sp-dem-rw right" style={{ paddingBottom: '7px' }}>
          <span
            className="clear-right actn-No"
            style={{ width: '25%', textAlign: 'center' }}
            onClick={handleClose}
          >
            Close
          </span>
        </div>
      </div>
    </div>
  );
}

export default FutureAppListPopup;
